import useTspApiResource from "../../hooks/useTspApiResource";
import TspApiService from "../../api/tspApiService";

// GET /api/tsp/stats — one journey's summary ("Your Stats"). `journeyId` is
// optional: omitted, the server picks the caller's own running journey (or
// the one they touched last). Each section is `null` when the caller lacks
// that record type's own view permission.
// Refreshed silently every minute and on tab focus, so a running journey's
// figures follow what the team records.
export const STATS_REFRESH_MS = 60000;

export function useTspTempleStatsData() {
  const { data, loading, error, reload } = useTspApiResource(() => TspApiService.getTempleStats(), [], { refreshMs: STATS_REFRESH_MS });
  return { data, loading, error, reload };
}

export default function useTspStatsData(journeyId) {
  const { data, loading, error, reload } = useTspApiResource(() => TspApiService.getJourneyStats(journeyId), [journeyId], { refreshMs: STATS_REFRESH_MS });
  return { data, loading, error, reload };
}
